import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 27,
	viewBox: "0 0 30 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27.2703 19.2459L27.7228 19.3097L29.8615 4.03668C29.938 3.49012 29.5573 2.98489 29.0108 2.90781L9.38687 0.13981C8.83961 0.0626176 8.3335 0.443995 8.25686 0.991331L7.81024 4.18081H9.19178L9.56078 1.54564L28.4646 4.21209L27.2703 12.7404V19.2459ZM2.72662 10.4009L0.995532 10.5529C0.445612 10.6012 0.0388465 11.0859 0.086786 11.6359L1.33919 26.0031C1.38717 26.5536 1.87247 26.9608 2.42288 26.9125L22.1642 25.179C22.7141 25.1307 23.1209 24.646 23.0729 24.096L23.007 23.34H21.6383L21.6825 23.8476L2.6656 25.5174L1.47719 11.8843L2.72662 11.7746V10.4009ZM4.09016 6.54932C4.09016 5.99704 4.53788 5.54932 5.09016 5.54932H24.9068C25.4591 5.54932 25.9068 5.99704 25.9068 6.54932V20.9715C25.9068 21.5238 25.4591 21.9715 24.9068 21.9715H5.09016C4.53788 21.9715 4.09016 21.5238 4.09016 20.9715V6.54932ZM5.4537 6.91784H24.5433V20.603H5.4537V6.91784Z",
		fill: "black"
	})
});
export default SvgStock;
